<template>
	<div>
        <!-- <v-bottom-sheet persistent v-model="dialog_selection" v-if="dialog_selection"> -->
        <dialog ref="ref_nativeDialog" class="native_dialog" style="min-width: 280px;" v-if="dialog_share_transaction">
            <v-card flat>
                <!-- <v-subheader>Share Transaction</v-subheader> -->
                <v-card-text full-height nopadding>
                    <v-list>
                        <v-list-tile @click="actionMethod('pdf')">
                            <v-list-tile-avatar><v-icon>picture_as_pdf</v-icon></v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Share as PDF</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="actionMethod('image')">
                            <v-list-tile-avatar><v-icon>image</v-icon></v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>Share as Image</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </dialog>
        <!-- </v-bottom-sheet> -->
	</div>
</template>

<script>
	export default{
		props:['actionMethod'],
		data(){
			return{
				dialog_share_transaction:false,
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_share_transaction = true;
                setTimeout(() => {
					this.$refs['ref_nativeDialog'].showModal();
				}, 100);
			},
			closeDialogWeb: function () {
                this.$refs['ref_nativeDialog'] ? this.$refs['ref_nativeDialog'].close() : '';
				this.dialog_share_transaction = false;
			}
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_share_transaction.vue